import React, { useEffect } from 'react'
import { CFSelect, CFView, LocationSelect, MobileScreen } from 'components'
import Header from './Header'
import Hero from './Hero'
import Promotions from './Promotions'
import About from './About'
import Gallery from './Gallery'
import Contact from './Contact'
import Footer from './Footer'
import WelcomeModal from './WelcomeModal'
import WelcomePromo from './WelcomePromo'
import { dispatch } from 'store'

export default () => {
  useEffect(() => {
    dispatch.restaurant.setLocationId('8nQRzNgP2rovh82MXE4Q')
  })

  return (
    <CFView row justifyCenter>
      <CFView maxWidth="1400px" w="100%" bg="black">
        {/* <MobileScreen>
          <LocationSelect />
        </MobileScreen> */}
        {/* <Header /> */}
        <Hero />
        <About />
        <Promotions />
        <Gallery />
        <Contact />
        <Footer />
      </CFView>
      <CFSelect selector={dispatch.restaurant.getWelcomeMessage}>
        <WelcomePromo />
        {/* <WelcomeModal /> */}
      </CFSelect>
    </CFView>
  )
}
